import { render } from "./ReasonForChange.vue?vue&type=template&id=2c597e91"
import script from "./ReasonForChange.vue?vue&type=script&lang=js"
export * from "./ReasonForChange.vue?vue&type=script&lang=js"

import "./ReasonForChange.vue?vue&type=style&index=0&id=2c597e91&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__